import React, { useState, useEffect } from "react";
import { BookmarkIcon } from "../bookmark-icon";
import { string, object } from "prop-types";
import useUrl from "../../../hook/useUrl";
import { connect } from "react-redux";
import "./sticky-social-share.m.css";
import get from "lodash/get";
import cx from "classnames";

const StickySocialShareTemplate = props => {
  const [, currentUrlSlug] = useUrl();
  const socialShareStyle = cx({
    "social-share": true
  });
  const story = props.story;
  const [wListed, setWlisted] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDeviceDesktop, setIsDeviceDesktop] = useState(false);
  const isCommentingOn = get(story, ["metadata", "story-attributes", "kommentointi", 0]);
  const [isVisible, setIsVisible] = useState(false);

  const [copyButtonText, setCopyButtonText] = useState('Kopioi linkki')

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true); // Update state to make the element visible
    }, 700);

    return () => clearTimeout(timer); // Cleanup timeout if component unmounts
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    } else {
      const listed = JSON.parse(window.localStorage.getItem("ipUser"));
      setWlisted(listed)
    }

    //detects if device is mobile or desktop
    const mobileDevices = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    if (mobileDevices.test(navigator.userAgent)) {
      setIsDeviceDesktop(false);
    } else {
      setIsDeviceDesktop(true);
    }

  }, [])

  const handleCopyLink = (e) => {
    navigator.clipboard.writeText(window.location.href);
    setCopyButtonText('Kopioitu');
    setTimeout(() => {
      setCopyButtonText('Kopioi linkki');
      handleDropdown(e);
    }, 2000); // Change text back after 2 seconds
  };

  function handleClick() {
    if (isDeviceDesktop) {
      toggleDropdown();
    } else {
      shareContent();
    }
  }

  // Function to toggle dropdown visibility
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const showDropdownContent = () => {
    return (
      <ul>
        <li styleName="social-share-icon" className="social-share-icon">
          <a href={props.fbUrl} onClick={handleDropdown} target="_blank" rel="noopener noreferrer" title="Facebook">
            <i className="ri-facebook-fill" id="ri-facebook-fill"></i> Facebook
          </a>
        </li>
        <li styleName="social-share-icon" className="social-share-icon">
          <a href={props.twitterUrl} onClick={handleDropdown} target="_blank" rel="noopener noreferrer" title="X">
            <i className="ri-twitter-x-fill" id="ri-twitter-x-fill"></i> X
          </a>
        </li>
        <li styleName="social-share-icon" className="social-share-icon" >
          <a href={`${props.whatsappUrl}?utm_source=wa-jako`} onClick={handleDropdown} title="WhatsApp" target="_blank" rel="noopener noreferrer">
            <i className="ri-whatsapp-line" id="ri-whatsapp-line"></i> WhatsApp
        </a>
        </li>
        <li styleName="social-share-icon" className="social-share-icon" >
          <a href={`${props.linkedinUrl}`} onClick={handleDropdown} title="LinkedIn" target="_blank" rel="noopener noreferrer">
            <i className="ri-linkedin-fill" id="ri-linkedin-fill"></i> LinkedIn
          </a>
        </li>
        <li styleName="social-share-icon" className="social-share-icon">
          <a href={props.mailtoUrl} onClick={handleDropdown} title="Sähköposti" target="_blank" rel="noopener noreferrer">
            <i className="ri-mail-line" id="ri-mail-line"></i> Sähköposti
          </a>
        </li>
        <li styleName="social-share-icon" className="social-share-icon">
          <button onClick={handleCopyLink} title="Kopioi linkki" styleName="copy-link">
            <i className="ri-link" id="ri-link"></i> {copyButtonText}
          </button>
        </li>
      </ul>
    )
  }

  //shows devices own sharing options
  async function shareContent() {
    if (navigator.share) {
      try {
        await navigator.share({
          url: window.location.href,
        });
        console.log('Content shared successfully');
      } catch (error) {
        console.error('Error sharing content:', error);
      }
    }
  }

  //Handles dropdown closing when dropdown menu's link is clicked
  function handleDropdown(e) {
    e.stopPropagation(); // This prevents the event from bubbling up to parent elements
    if (isDeviceDesktop) {
      setIsDropdownOpen(!isDropdownOpen);
    }
  }


  return (
    <>
      {<ul className="sticky-wrapper voice-no-read" styleName={isVisible ? 'sticky-social-share visible' : 'sticky-social-share'}>
          <li styleName="social-shares" className="social-share-icon">
            <button onClick={handleClick} title="Jaa">
              <i className="ri-share-line" id="ri-share-line"></i>
              <span styleName="btn-type-text" className="btn-type-text">Jaa</span>
            </button>
            {isDropdownOpen && (
              <div className="social-share-dropdown-menu" styleName="social-share-dropdown-menu">
                {/* Dropdown menu content here */}
                {showDropdownContent()}
              </div>
            )}
          </li>
          {!wListed && <li styleName="bookmark-social-share" className="bookmark-social-share-icon">
            <BookmarkIcon user_flag="bm_user_flag" storyObj={props.story} showBookmark={true} removeStory={false} socialShare />
          </li>}
          {(!wListed && isCommentingOn !== "pois" && story["story-template"] !== "wau-juttu" && story["story-template"] !== "natiivi") && <li styleName="commentcount-social-share" className="commentcount-social-share-icon">
            <button onClick={() => document.getElementById('coral-top-container').scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" })} title="Keskustele">
              {<span
                className="coral-count"
                data-coral-id={props.story.id}
                data-coral-notext="true">
                <span class="coral-count-number">0</span> {/* Class is needed for fetching from coral */}
              </span>}
              <i className="ri-chat-1-line"></i>
              <span styleName="btn-type-text" className="btn-type-text">Keskustele</span>
            </button>
          </li>}
        </ul>}
    </>
  );
};

StickySocialShareTemplate.propTypes = {
  twitterUrl: string,
  whatsappUrl: string,
  fbUrl: string,
  linkedinUrl: string,
  mailtoUrl: string,
  currentHostUrl: string,
  url: string,
  story: object
};

const mapStateToProps = state => {
  return {
    currentHostUrl: get(state, ["qt", "currentHostUrl"], "")
  };
};

export default connect(mapStateToProps, null)(StickySocialShareTemplate);
